import { Avatar, Box, lighten } from '@mui/material';

import { DataGridPremium } from '@mui/x-data-grid-premium';
import { daDK } from '@mui/x-data-grid/locales';
import { getTypeColor, getTypeIcon } from '../../../../utils/powerSource';
import { formatNumber } from '@/utils/formatters';
import { useTranslation } from 'react-i18next';

const GridMixDatagrid = (props) => {
  const { t } = useTranslation('energyxplorer-esg');
  const { gridMixData, selectedList } = props;

  if (gridMixData === null) return;

  const columns = [
    {
      field: 'icon',
      headerName: '',
      flex: 1,
      renderCell: (params) => {
        const EnergyIcon = getTypeIcon(params.row.name);
        return (
          <Box display="flex" alignItems="center" width="100%" height="100%">
            <Avatar
              sx={{
                borderRadius: 2,
                backgroundColor:
                  selectedList.includes(params.row.name) ||
                  selectedList.length === 0
                    ? lighten(getTypeColor(params.row.name), 0.2)
                    : 'divider',
              }}
              variant="rounded"
              size="small"
            >
              <EnergyIcon />
            </Avatar>
          </Box>
        );
      },
    },
    {
      field: 'name',
      headerName: t('energy_distribution_datagrid.columns.source'),
      flex: 1,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              color:
                selectedList.includes(params.row.name) ||
                selectedList.length === 0
                  ? 'textPrimary'
                  : 'divider',
            }}
          >
            {params.value}
          </Box>
        );
      },
    },
    {
      field: 'y',
      headerName: t('energy_distribution_datagrid.columns.contribution'),
      flex: 1,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              color:
                selectedList.includes(params.row.name) ||
                selectedList.length === 0
                  ? 'textPrimary'
                  : 'divider',
            }}
          >
            {params.formattedValue}
          </Box>
        );
      },
      valueFormatter: (value) => formatNumber(value) + '%',
    },
  ];

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <DataGridPremium
        localeText={daDK.components.MuiDataGrid.defaultProps.localeText}
        rows={gridMixData.map((o, index) => ({ ...o, id: index }))}
        columns={columns}
        rowSelection={false}
        cellSelection={false}
        hideFooter
        sortingOrder={['desc', 'asc', null]}
        initialState={{
          sorting: {
            sortModel: [{ field: 'y', sort: 'desc' }],
          },
        }}
        sx={{
          borderRadius: 2,
          '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, \
             & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
            {
              outline: 'none',
            },
          '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 'bold' },
          '& .MuiDataGrid-main': (theme) => ({
            backgroundColor:
              theme.palette.mode === 'light' ? '#fff' : '#121212',
          }),
          '& .MuiDataGrid-toolbarContainer': (theme) => ({
            backgroundColor:
              theme.palette.mode === 'light' ? '#fff' : '#121212',
          }),
          '& .MuiDataGrid-root': (theme) => ({
            borderColor: theme.palette.divider,
          }),
          '& .MuiDataGrid-columnHeaders': {
            borderBottom: '1px solid',
            borderColor: 'divider',
          },
          '& .selected-row': {
            backgroundColor: (theme) => theme.palette.action.selected,
            '&:hover': {
              backgroundColor: (theme) => theme.palette.action.selected,
            },
          },
        }}
      />
    </div>
  );
};

export default GridMixDatagrid;
